import { Program } from '.';
import { Playlist } from './playlist';
import { Lesson } from './lesson';
export const SEARCH_LIMIT_PER_PAGE = 20;
export const SEARCH_PAGE_INIT = 1;
export class SearchResult {
    constructor(searchData, config) {
        Object.defineProperty(this, "lessons", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: null
        });
        Object.defineProperty(this, "programs", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: null
        });
        Object.defineProperty(this, "playlists", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: null
        });
        Object.defineProperty(this, "lessonsCount", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "programsCount", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "playlistsCount", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "perPage", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        if (searchData.lessons) {
            this.lessons = searchData.lessons.map((o) => new Lesson(o, config));
        }
        if (searchData.programs) {
            this.programs = searchData.programs.map((o) => new Program(o, config));
        }
        if (searchData.playlists) {
            this.playlists = searchData.playlists.map((o) => new Playlist(o, config));
        }
        this.lessonsCount = searchData.lessonsCount;
        this.programsCount = searchData.programsCount;
        this.playlistsCount = searchData.playlistsCount;
        this.perPage = searchData.perPage;
    }
}
